import * as React from 'react';
import './ReturnsTable.scss';
import ReturnsRow from '../ReturnsRow';
import { IEligibleItem } from 'src/services/returns/typings';
import AlertCustom from 'src/components/common/AlertCustom';

interface IReturnsTableProps {
  partsToReturn: IEligibleItem[];
  removeItemFromReturn: (id: number) => void;
  editPartFromReturnList: (part: IEligibleItem) => void;
  t?: any;
}

const ReturnsTable: React.FC<IReturnsTableProps> = props => {
  const {
    partsToReturn,
    removeItemFromReturn,
    editPartFromReturnList,
    t
  } = props;
  const [isShowTableHistoryInfo, setIsShowTableHistoryInfo] = React.useState<boolean>(false);
  const [isShowTableHistoryInfoForRow, setIsShowTableHistoryInfoForRow] = React.useState<boolean>(true);

  React.useEffect(()=>{
  const partsInHistoryArr:any=[];
    partsToReturn.map((partToReturn, index) => {
      if(partToReturn.noOfTimesPartInvoicedInLast90Days>1){
        partsInHistoryArr.push(partToReturn.id);
      }
    });
    if(partsInHistoryArr.length>0){
      setIsShowTableHistoryInfo(true);
    }else{
      setIsShowTableHistoryInfo(false);
    }
  },[partsToReturn])

  const handleTableCloseAlert = () => {
    setIsShowTableHistoryInfo(false);
    setIsShowTableHistoryInfoForRow(false);
  }

  const removeAllPartsFromCart = () => {
    partsToReturn.map((partToReturn, index) => {
      if(partToReturn.noOfTimesPartInvoicedInLast90Days>1){
        removeItemFromReturn(partToReturn.id);
      }
    });
    setIsShowTableHistoryInfo(false);
  }

  return (
    <div className="rp-returns-table">
        {isShowTableHistoryInfo &&
          <div className="container-fluid">
          <div className="row">
            <AlertCustom
              type="lwarning"
              styleClass="rp-return-row-history-table-info--alert"
              icon={'icon="rpds-check-circle"'}
              handleCloseAlert={null}
              removeItemFromReturn={null}
              handleTableCloseAlert={handleTableCloseAlert}
              removeAllPartsFromCart={removeAllPartsFromCart}
              id={1}
              message={t('myReturns.removeAllPartFromReturnCartWarning')}
            />
            </div>
            </div>
        }
      <div className="container-fluid">
        <div className="row rp-returns-table-headers">
          <div className="col-16">
            <p className="rp-returns-table-header">{t('myReturns.partNo')} </p>
          </div>
          <div className="col-14">
            <p className="rp-returns-table-header">
              {t('myReturns.invoiceNo')}
            </p>
          </div>
          <div className="col-9">
            <p className="rp-returns-table-header">{t('myReturns.price')}</p>
          </div>
          <div className="col-11">
            <p className="rp-returns-table-header">
              {t('myReturns.returnQty')}
            </p>
          </div>
          <div className="col-14">
            <p className="rp-returns-table-header">
              {t('myReturns.restockingFee')}
            </p>
          </div>
          <div className="col-17">
            <p className="rp-returns-table-header">
              {t('myReturns.reasonReference')}
            </p>
          </div>
        </div>
      </div>
      <div className="rp-returns-table-row-container">
        {partsToReturn.map(partToReturn => (
          <ReturnsRow
            key={partToReturn.id}
            partToReturn={partToReturn}
            removeItemFromReturn={removeItemFromReturn}
            editPartFromReturnList={editPartFromReturnList}
            isShowTableHistoryInfoForRow={isShowTableHistoryInfoForRow}
          />
        ))}
      </div>
    </div>
  );
};

export default ReturnsTable;
